    <template>
        <div class="my-multiselect-container">
            <input type="hidden" :name="name" :id="id" v-model="selectedValue" :disabled="disabled || disableInput" >
            <vue-multiselect
                v-model="selectedOption"
                :options="options"
                :label="label"
                :placeholder="placeholder"
                :customLabel="onUnderline ? customUnderlineLabel : customLabel"
                :disabled="disabled"
                :readonly="readonly"
                :searchable="searchable"
                :close-on-select="closeOnSelect"
                :clear-on-select="clearOnSelect"
                :allow-empty="allowEmpty"
                :preserve-search="preserveSearch"
                :taggable="taggable"
                :reset-after="resetAfter"
                :show-labels="false"
                :loading="loading"
                :internal-search="internalSearch"
                @search-change="asyncFind"
                @select="onSelect"
            >
                <template slot="singleLabel" slot-scope="{ option }">
                    <slot name="singleLabel" :option=option>
                    </slot>
                </template>
                <template v-if="useSearchIcon" v-slot:caret>
                    <i class="caret-icon bi bi-search"></i>
                </template>
                <template v-slot:noResult>
                    Não foi encontrado nenhum item. Tente mudar sua pesquisa
                </template>
                <template v-slot:noOptions>
                    Não foi encontrado nenhum item. Tente mudar sua pesquisa
                </template> 
                <template v-slot:option="{ option }">
                    <div
                        class="custom-option d-flex align-items-center px-2 py-1"
                        style="cursor: pointer;"
                        @click="selectedOption = option"
                    >
                        <input
                        type="radio"
                        :name="id"
                        class="form-check-input me-2"
                        :checked="selectedOption && option.value === selectedOption.value"
                        @change="$emit('select', option)"
                        />
                        <span>{{ option.text }}</span>
                    </div>
                </template>
            </vue-multiselect>
        </div>
    </template>

<script>
import Multiselect from 'vue-multiselect'

export default {   
    components: { 'vue-multiselect': Multiselect },
    props:{
        name: String,
        id: String,
        value: String|Number,
        default: String|Number,
        icon: {
            type: String,
            default: 'arrow',
            validator: (value)=>{
                return ['arrow', 'search'].includes(value);
            }
        },
        taggable: {
            type: Boolean,
            default: false
        },
        label: String,
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disableInput: {
            type: Boolean,
            default: false
        },
        searchable: {
            type: Boolean,
            default: true
        },
        closeOnSelect: {
            type: Boolean,
            default: true
        },
        clearOnSelect: {
            type: Boolean,
            default: true
        },
        preserveSearch: {
            type: Boolean,
            default: false
        },
        internalSearch: {
            type: Boolean,
            default: false
        },
        allowEmpty: {
            type: Boolean,
            default: true
        },
        resetAfter: {
            type: Boolean,
            default: false
        },
        clearOnOptionChange: {
            type: Boolean,
            default: false,
        },
        optionsLimit: {
            type: Number,
            default: undefined
        },
        options: {
            type: Array,
            default: ()=>[]
        },
        loading: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: 'Selecione uma opção'
        },
        asyncFind: {
            type: Function,
            default: (searchQuery, id) => {}
        },
        onSelect: {
            type: Function,
            default: (selectedOption, id) =>{}
        },
        onUnderline: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return {
            selectedOption: null,
            selectedValue: null,
        }
    },
    beforeMount(){
        // console.log(this.clearOnOptionChange);
        if(this.value != null){
            this.selectedOption = this.options.find(option=>option.value==this.value);
        }else if (this.value == null && this.default !=null){
            this.selectedOption = this.options.find(option=>option.value==this.default);
        }
    },
    computed: {
        useSearchIcon(){
            return this.icon == 'search';
        },
    },
    watch: {
        selectedOption(newVal) {
            this.selectedValue = newVal ? newVal.value : null;
            this.$emit('input', newVal ? newVal.value : null);
        },
        value(newVal) {
            this.selectedOption = this.options.find(option => option.value == newVal);
        },
        options(newVal) {
            if(this.clearOnOptionChange)
                this.selectedOption = null;
        }
    },
    methods: {
        customLabel(option){
            return option.text.replaceAll('_', ' ')
        },
        customUnderlineLabel(option){
            return option.text
        },
        asyncFind(val) {
            this.$emit('search-change', val);
        },
        onSelect(val) {
            this.$emit('select', val);
        }
    },
}

</script>